import React, { Component } from 'react'
import { Sidebar, Segment, Container, Menu, List, Icon, Responsive } from 'semantic-ui-react'
import { Link,withRouter } from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

const containerStyle = {
  height: 'auto',
  width: '1400px',
  padding: '1em 0em',
  border:'none',
  'font-family': 'Lato', 
  'font-size': '12px',
  'color': 'grey',
  //'border-style':'solid',
  //'border-width': '0.5px',
 'background-color': '#f9f9f9',
 // backgroundImage: `url(${backgroundImg})`,
 // backgroundSize: 'cover'
};


class SideLeftUncoverMenu extends Component {
  state = { visible: false }

  isActive(match1){
    return this.props.location.pathname.indexOf(match1)!=-1
  }

  render() {
    const { id } = this.props;
    return (
      <div>
      <Responsive minWidth={Responsive.onlyComputer.minWidth}>
        {/* <Segment textAlign='left' style={{ minHeight:40, padding: '1em 0em' }} basic vertical> */}
          <Sidebar.Pushable as={Container} style={containerStyle}>
            <Sidebar as={List} 
                    selection 
                    animation='uncover' 
                    width='thin' 
                    visible={true} 
                    icon='labeled' 
                    vertical
                    size='large'>
               <br/>
               <List.Item disabled>
                      <FormattedMessage id="menu.computer.sidemenu.menu.top.title"
                                        defaultMessage='Menu Actions'/>
               </List.Item>
                <List.Item name='View Menus' as={Link} to='/menus'>
                  <Icon name='home' color={this.isActive('menus')?'blue': 'black'} />
                  <List.Content>
                    <List.Header style={this.isActive('menus')?{'color': '#0d77b5'}:{'color': 'black'}}>
                        <FormattedMessage id="menu.computer.sidemenu.menu.elem1.title"
                                          defaultMessage='Menus'/>
                    </List.Header>
                  </List.Content>
                </List.Item>
                <List.Item name='Details Menu' disabled = {!id} as={Link} to={'/editmenu/'+ id } >
                  <Icon name='folder open outline' color={this.isActive('editmenu')?'blue': 'black'}/>
                  <List.Content>
                    <List.Header style={this.isActive('editmenu')?{'color': '#0d77b5'}:{'color': 'black'}}>
                      <FormattedMessage id="menu.computer.sidemenu.menu.elem2.title"
                                          defaultMessage='Details'/>
                    </List.Header>
                  </List.Content>
                 </List.Item>
                 <List.Item name='Print Menu' disabled = {!id} as={Link} to={'/printmenu/'+ id }>
                  <Icon name='print' color={this.isActive('printmenu')?'blue': 'black'}/>
                  <List.Content>
                    <List.Header style={this.isActive('printmenu')?{'color': '#0d77b5'}:{'color': 'black'}}>
                        <FormattedMessage id="menu.computer.sidemenu.menu.elem4.title"
                                          defaultMessage='Export'/>
                    </List.Header>
                  </List.Content>
                </List.Item>
                <List.Item name='Delete Menu'  disabled = {!id} as={Link} to={'/deletemenu/'+ id }>
                  <Icon name='trash alternate outline' color={this.isActive('deletemenu')?'blue': 'black'}/>
                  <List.Content>
                    <List.Header style={this.isActive('deletemenu')?{'color': '#0d77b5'}:{'color': 'black'}}>
                        <FormattedMessage id="menu.computer.sidemenu.menu.elem3.title"
                                          defaultMessage='Delete'/>
                    </List.Header>
                  </List.Content>
                </List.Item>
            </Sidebar>
            <Sidebar.Pusher style={{  'min-height': '100vh',overflowY: 'auto', width: '100%', padding: '2em 2em 2em 3em','background-color': '#fcfcfc'}}>
                  {this.props.children} 
              </Sidebar.Pusher>
          </Sidebar.Pushable>
        {/* </Segment> */}
      </Responsive>
      <Responsive  minWidth={Responsive.onlyMobile.maxWidth} maxWidth={Responsive.onlyTablet.maxWidth}>
          <Menu secondary>
              <Menu.Item  onClick={() => this.setState({ visible: !this.state.visible })} >
                  <Icon name="sidebar"/><FormattedMessage id="menu.mobile.sidemenu.menu.top.title"
                                                           defaultMessage='Menu'/>
              </Menu.Item>          
          </Menu>
          <Sidebar.Pushable as={Segment}>
              <Sidebar 
                  width='thin'
                  as={Menu} 
                  animation="push" 
                  direction="top" 
                  visible={this.state.visible} 
                  icon="labeled" 
                  horizontal
                  size='tiny'>
                {/* <Container> */}
{/*                 <Menu.Item name='New Recipe' as={Link} to={'/newrecipe'}>
                      <Icon name='add'/>
                      Add Recipe
                  </Menu.Item> */}
                   <Menu.Item name='View'as={Link} to='/menus'>
                      <Icon name='home' color={this.isActive('menus')?'blue': 'black'}/>
                      <FormattedMessage id="menu.mobile.sidemenu.menu.elem1.title"
                                          defaultMessage='Menus'/>
                    </Menu.Item>
                    <Menu.Item name='Details Menu'  disabled = {!id} as={Link} to={'/editmenu/'+ id}>
                      <Icon name='folder open outline' color={this.isActive('editmenu')?'blue': 'black'}/>
                      <FormattedMessage id="menu.mobile.sidemenu.menu.elem2.title"
                                        defaultMessage='Details'/>
                  </Menu.Item>
                  <Menu.Item name='Print Menu'  disabled = {!id} as={Link} to={'/printmenu/'+ id }>
                      <Icon name='print' color={this.isActive('printmenu')?'blue': 'black'}/>
                      <FormattedMessage id="menu.mobile.sidemenu.menu.elem4.title"
                                        defaultMessage='Export'/>
                  </Menu.Item>
                  <Menu.Item name='Delete Menu' disabled = {!id} as={Link} to={'/deletemenu/'+ id} >
                      <Icon name='trash alternate outline' color={this.isActive('deletemenu')?'blue': 'black'}/>
                      <FormattedMessage id="menu.mobile.sidemenu.menu.elem3.title"
                                        defaultMessage='Delete'/>
                  </Menu.Item>
                {/* </Container>   */}
              </Sidebar>
              <Sidebar.Pusher dimmed={this.state.visible} style={{minHeight: '100vh', overflow: 'auto', padding: '2em 0em 2em 2em' }}>
                    {this.props.children}
              </Sidebar.Pusher>
          </Sidebar.Pushable>
      </Responsive>
      <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
          <Menu secondary>
              <Menu.Item  onClick={() => this.setState({ visible: !this.state.visible })} >
                  <Icon name="sidebar"/><FormattedMessage id="menu.mobile.sidemenu.menu.top.title"
                                                           defaultMessage='Menu'/>
              </Menu.Item>          
          </Menu>
          <Sidebar.Pushable as={Segment}>
              <Sidebar 
                  width='thin'
                  as={Menu} 
                  animation="push" 
                  direction="top" 
                  visible={this.state.visible} 
                  icon="labeled" 
                  horizontal
                  size='tiny'>
                   <Menu.Item name='View'as={Link} to='/menus'>
                      <Icon name='home' color={this.isActive('menus')?'blue': 'black'}/>
                      <FormattedMessage id="menu.mobile.sidemenu.menu.elem1.title"
                                          defaultMessage='Menus'/>
                    </Menu.Item>
                  <Menu.Item name='Details Menu' disabled = {!id} as={Link} to={'/editmenu/'+ id }>
                      <Icon name='folder open outline' color={this.isActive('editmenu')?'blue': 'black'}/>
                      <FormattedMessage id="menu.mobile.sidemenu.menu.elem2.title"
                                        defaultMessage='Details'/>
                  </Menu.Item>
                  <Menu.Item name='Print Menu' disabled = {!id} as={Link} to={'/printmenu/'+ id }>
                      <Icon name='print' color={this.isActive('printmenu')?'blue': 'black'}/>
                      <FormattedMessage id="menu.mobile.sidemenu.menu.elem4.title"
                                        defaultMessage='Export'/>
                  </Menu.Item>
                  <Menu.Item name='Delete Menu' disabled = {!id} as={Link} to={'/deletemenu/'+ id} >
                      <Icon name='trash alternate outline' color={this.isActive('deletemenu')?'blue': 'black'}/>
                      <FormattedMessage id="menu.mobile.sidemenu.menu.elem3.title"
                                        defaultMessage='Delete'/>
                  </Menu.Item>
              </Sidebar>
              <Sidebar.Pusher dimmed={this.state.visible} style={{minHeight: '100vh', overflow: 'auto', padding: '2em 0em 2em 0em' }}>
                    {this.props.children}
              </Sidebar.Pusher>
          </Sidebar.Pushable>
      </Responsive>
      </div>
    )
  }
}

export default withRouter(SideLeftUncoverMenu)
